<div id="infra">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Fire Fighting Equipment</h4>
                  <div class="card-body">
                    <p class="inner-lead">Welcome to our school's fire safety equipment page. The safety of our students, staff, and visitors is our top priority, and we take every precaution necessary to ensure a safe learning environment. Our school is equipped with state-of-the-art fire safety equipment and protocols to help prevent and respond to potential fire emergencies.
                    </p>  
                    <p class="inner-lead">Our school is equipped with fire extinguishers located throughout the building, including in classrooms, hallways, and common areas. At our school, we take fire safety very seriously and work closely with local fire departments to ensure that our fire safety protocols and equipment are up-to-date and effective.</p>
                    <p class="inner-lead">We also understand that fire safety is a community effort, and we encourage our students and families to take steps to ensure fire safety at home as well. Our school regularly hosts fire safety education programs and workshops, where students and families can learn about fire prevention, emergency preparedness, and other important fire safety topics. We believe that by working together, we can create a safer community and ensure the well-being of everyone in our school and beyond.</p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>